package com.svdsak.style

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.percent

val FooterContentStyle = CssStyle {
    base {
        Modifier
            .color(Color.rgb(255, 255, 255))
            .padding(topBottom = 1.percent, leftRight = 2.5.percent)
    }
}